var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.email.email_group"),
            isTitleUpperCase: false,
          },
        },
        [
          _c(
            "b-row",
            [
              !_vm.readonly
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.email.group_name"),
                        },
                        model: {
                          value: _vm.GroupName,
                          callback: function ($$v) {
                            _vm.GroupName = $$v
                          },
                          expression: "GroupName",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.email.group_name"),
                          inputValue: _vm.GroupName,
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.mode === "add"
        ? _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.email.email_address"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn w-auto px-4 btn-tertiary mb-5",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.addEmailAddress.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.email.email_address_add")))]
              ),
              _vm._v(" "),
              _vm._l(_vm.emailAddList, function (emailAdd, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "rounded p-4 trackingAccordion mb-5",
                  },
                  [
                    _c(
                      "b-row",
                      [
                        !_vm.readonly
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t(
                                      "common.email.email_address_name"
                                    ),
                                  },
                                  model: {
                                    value: emailAdd.Name,
                                    callback: function ($$v) {
                                      _vm.$set(emailAdd, "Name", $$v)
                                    },
                                    expression: "emailAdd.Name",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.readonly
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t(
                                      "common.email.email_address"
                                    ),
                                  },
                                  model: {
                                    value: emailAdd.Email,
                                    callback: function ($$v) {
                                      _vm.$set(emailAdd, "Email", $$v)
                                    },
                                    expression: "emailAdd.Email",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn w-auto px-4 btn-tertiary",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.removeEmailAddress(index, emailAdd)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("common.email.email_address_delete"))
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }